import { styled } from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';
import { StyledAlertDialogContent } from '@/shared/ui/alert-dialog/styles';
import {
  BodyTextRegularTertiary,
  BodyTextRegularQuaternary,
} from '@/shared/ui/typography';
import { Image } from '@/shared/ui/image/Image';

const StyledHistoryDialogContent = styled(StyledAlertDialogContent)`
  display: flex;
  width: 420px;
  height: 617px;
  max-height: calc(min(617px, 98dvh));
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  // justify-content: stretch;

  padding: 18px;
  gap: 24px;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    max-height: calc(100% - 60px);
    margin-bottom: 44px;
  }
`;
const Title = styled(Dialog.Title)`
  margin: 0;
`;
const Navigation = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
`;
const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: flex-start;
  height: 408px;
  flex-grow: 1;
  margin-bottom: auto;
  // justify-self: stretch;
  // align-items: stretch;
  align-self: stretch;
  gap: 3px;
  overflow-y: auto;
  scrollbar-width: none; /* Для Firefox */
  -ms-overflow-style: none; /* Для Edge/IE */

  /* Для Chrome/Safari */
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Item = styled.div<{ index: number; total: number }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  box-sizing: border-box;
  align-items: stretch;
  align-self: stretch;
  height: 65px;
  flex: 0 0 auto;

  padding: 12px;
  align-items: center;
  gap: 10px;
  // align-self: stretch;

  border-radius: ${(props) =>
    props.index == 0
      ? '8px 8px 0px 0px'
      : props.index == props.total - 1
        ? '0px 0px 8px 8px'
        : 0};
  background: #27262b;

  @media screen and (max-width: 768px) {
    height: 62px;
  }
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  justify-content: flex-start;
  align-items: stretch;
  align-self: stretch;

  align-items: center;
  gap: 4px;
`;

const DateStyleDesktop = styled(BodyTextRegularTertiary)`
  color: #afafaf;
  text-align: right;
`;
const DateStyleMobile = styled(BodyTextRegularQuaternary)`
  color: #afafaf;
  text-align: right;
`;

const CloseIconImage = styled(Image)`
  cursor: pointer;
  & img {
    width: 32px;
    height: 32px;
  }
`;
const HistoryIconImage = styled(Image)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;

  border-radius: 1000px;
  background: #3d383f;
  & img {
    width: 20px;
    height: 20px;
  }
`;

export {
  StyledHistoryDialogContent,
  Title,
  Navigation,
  ItemsList,
  Item,
  Details,
  DateStyleDesktop,
  DateStyleMobile,
  CloseIconImage,
  HistoryIconImage,
};
